import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import noop from '../noop';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
/** returns whether current user is logged in,
 *  a dispatched action that sends the user to the sisu login pages,
 *  and a function that will call a callback if logged in, send to login if not */ export function useRestrictToLoggedIn() {
    const isLoggedIn = useSelector(getIsLoggedIn);
    const dispatch = useDispatch();
    const sendUserToJoinPage = useCallback((restrictedActionName, returnTo, returnType)=>{
        yieldToMain(()=>{
            dispatch(restrictLoggedOut({
                restrictedActionName,
                returnTo,
                returnType
            }));
        });
    }, [
        dispatch
    ]);
    const restrictToLoggedIn = useCallback((restrictedActionName, callback = noop, returnTo, returnType)=>(...args)=>{
            return !isLoggedIn ? sendUserToJoinPage(restrictedActionName, returnTo, returnType) : yieldToMain(()=>{
                callback(...args);
            });
        }, [
        isLoggedIn,
        sendUserToJoinPage
    ]);
    return {
        isLoggedIn,
        sendUserToJoinPage,
        restrictToLoggedIn
    };
}

//# sourceMappingURL=useRestrictToLoggedIn.js.map